module.exports = __webpack_public_path__ + "static/RoHS-36ff47df77226dce88cc669a0888d8a6.png";